import { Component, input, output, inject } from '@angular/core';
import { TagColorService } from '../../../services/tag.service';

@Component({
    selector: 'em-tag-manager',
    templateUrl: './tag-manager.component.html',
    styleUrls: ['./tag-manager.component.scss'],
    standalone: false
})
export class TagManagerComponent {
  readonly tagColorService = inject(TagColorService);


  readonly tags = input<string[]>([]);

  readonly editable = input<boolean>(false);

  readonly add = output<string>();

  readonly remove = output<string>();

  readonly searchChange = output<string>();
}
